import { render, staticRenderFns } from "./PageGatewayGov.vue?vue&type=template&id=b56a6304&scoped=true&"
import script from "./PageGatewayGov.vue?vue&type=script&lang=js&"
export * from "./PageGatewayGov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56a6304",
  null
  
)

export default component.exports